export const aboutUsInfo = {
    "data": window.location.host != "open.iucn.org" ? [
        {
            img: '/static/assets/icons/partners.svg',
            title: 'Partner',
            id: 5,
            label: 'partner',
            image_2: '/static/assets/icons/partners.svg',
            desc: "IUCN is a democratic Union that brings together the world’s most influential organisations and top experts in a combined effort to conserve nature and accelerate the transition to sustainable development."
        },
        {
            img: '/static/assets/icons/delivery_model.svg',
            title: 'Delivery Models',
            id: 7,
            label: 'delivery_model',
            image_2: '/static/assets/icons/delivery_model.svg',
            desc: "Represent main strategies by which IUCN delivers its programme"
        }
    ] : [
            {
                img: '/static/assets/icons/partners.svg',
                title: 'Partner',
                id: 5,
                label: 'partner',
                image_2: '/static/assets/icons/partners.svg',
                desc: "IUCN is a democratic Union that brings together the world’s most influential organisations and top experts in a combined effort to conserve nature and accelerate the transition to sustainable development."
            },
        ]
}



// WEBPACK FOOTER //
// ./static/assets/json/undpAboutUsData.js